import styled, { css } from 'styled-components';
import { colors, Tooltip } from '@dexma/ui-components';

const valueSize = '2.8em';
const valueUnitSize = '0.6em';
const detailsSize = '1.2em';
const linkSize = '0.6em';
const compareValueSize = '1.6em';
const compareDetailsSize = '1.2em';

type WrapperProps = {
    fontSize?: number;
    href?: string;
    hrefTitle?: string;
    hasIcon?: boolean;
};

type ColorProps = {
    color: string;
};

const ellipsis = css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledOuterWrapper = styled.div<WrapperProps>`
    font-size: ${({ fontSize }) => fontSize}px;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
`;

export const StyledContent = styled.div<WrapperProps>`
    font-size: ${({ fontSize }) => fontSize}px;
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: ${({ hasIcon }) => (hasIcon ? '3%' : 'clamp(0px,10%,3vh)')};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 8px;
`;

export const StyledFlexIcon = styled.div`
    justify-content: center;
    flex: 3 1 0%;
    display: flex;
    align-items: center;
    width: 100%;
`;

export const StyledFlexContent = styled.div`
    flex: 7 1 0%;
    align-items: center;
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export const StyledBar = styled.div<ColorProps>`
    width: calc(100% - 16px);
    border-radius: 4px;
    margin: 8px 0 0 0;
    border-top: 4px solid ${({ color }) => color};
`;

export const StyledValue = styled.div`
    margin-top: 0.2em;
    line-height: 115%;
    ${ellipsis};
    text-overflow: ellipsis;
    width: 95%;
    display: flex;
    justify-content: center;
    font-size: ${valueSize};
    display: flex;
    color: ${colors.gray900};

    .unit {
        font-size: ${valueUnitSize};
        line-height: 230%;
    }
`;

export const StyledValueTooltip = styled(Tooltip)`
    text-align: center;
    margin-top: 0.2em;
    line-height: 115%;
    font-size: ${valueSize};
    ${ellipsis};
    max-width: 95%;
    display: flex;
    color: ${colors.gray900};

    .unit {
        font-size: ${valueUnitSize};
    }
`;

export const StyledDetails = styled.div`
    display: flex;
    text-align: center;
    justify-content: center;
    padding: 0 2em;
    .details-content {
        margin-bottom: 4px;
        font-size: ${detailsSize};
        color: ${colors.gray700};
        line-height: 115%;
    }
`;

export const StyledLinkIcon = styled(Tooltip)`
    position: absolute;
    right: 0.5em;
    bottom: 0;

    a {
        color: ${colors.gray500};
        text-decoration: underline;
        font-size: ${linkSize};
        font-weight: 600;
        margin-left: 16px;
        transition: color 0.5s ease;
    }

    a:hover {
        color: black;
    }
`;

export const StyledPinnedTooltip = styled(Tooltip)`
    background-repeat: no-repeat;
    background-position: right top;
    padding-right: 0.5em;
    background-size: 0.5em;
    background-image: url("data:image/svg+xml,%3Csvg width='14' height='20' viewBox='0 0 14 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 10C12.34 10 11 8.66 11 7V2H12C12.55 2 13 1.55 13 1C13 0.45 12.55 0 12 0H2C1.45 0 1 0.45 1 1C1 1.55 1.45 2 2 2H3V7C3 8.66 1.66 10 0 10V12H5.97V19L6.97 20L7.97 19V12H14V10ZM4 10C4.65 9.14 5 8.1 5 7V2H9V7C9 8.12 9.37 9.16 10 10H4Z' fill='%237E8084'/%3E%3C/svg%3E%0A");
    span {
        text-decoration: underline dotted;
        text-decoration-color: grey;
        text-underline-offset: 0.1em;
    }
`;

export const StyledPreposition = styled.span`
    color: ${colors.gray500};
    text-decoration: none !important;
`;

export const StyledCompareWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
export const StyledCompareValue = styled.span<ColorProps>`
    color: ${({ color }) => color};
    align-items: center;
    font-size: ${compareValueSize};
    display: flex;
`;

export const StyledCompareDetails = styled.span`
    font-size: ${compareDetailsSize};
    text-align: center;
    color: ${colors.gray500};
`;

export const StyledComparedArrow = styled.span<ColorProps>`
    margin-right: 8px;
    font-size: ${compareDetailsSize};
    color: ${({ color }) => color};
    font-weight: bold;
`;
